import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_COMMISSION_ENTRIES,
    FAILURE_COMMISSION_STATS,
    REQUEST_COMMISSION_ENTRIES,
    REQUEST_COMMISSION_STATS,
    SUCCESS_COMMISSION_ENTRIES,
    SUCCESS_COMMISSION_STATS,
} from './actions';

/*  Commission Account Stats  */
export function commissionStatsReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_COMMISSION_STATS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_STATS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_COMMISSION_STATS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Commission Account Entries */
export function commissionEntriesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_COMMISSION_ENTRIES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COMMISSION_ENTRIES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_COMMISSION_ENTRIES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
